export default "__VITE_ASSET__cbd72d44__"